<template lang="pug">
v-app(class="fill-height")
  div(v-if="loggedIn")
    div(v-if="usesPublicShell")
      core-view
    div(v-else)
      core-drawer
      v-main(id="main-container")
        v-layout(fill-height class="tw-h-full tw-overflow-hidden" style="background: #f5f5fa")
          v-row(no-gutters align="stretch" justify="start" class=" tw-h-full")
            v-col(v-if="displaySidebar" cols="auto" class="  xs:tw-hidden lg:tw-block tw-bg-white tw-w-1/6 ")
              kubiqa-nav-sidebar
            v-col(style="background: #f5f5fa")
              v-row(no-gutters align="stretch" justify="start" class="tw-h-full tw-w-full tw-content-start tw-flex")
                div(class=" tw-flex tw-flex-col tw-w-full tw-h-screen tw-overflow-hidden")
                  core-toolbar(v-if="displayMainToolbar")
                  kubiqa-website-toolbar(v-if="displayWebsiteToolbar")
                  core-view(class="tw-pb-2")

          //Dialogs
          kubiqa-dialogs-delete
          //kubiqa-dialogs-signup-subscription
  div(v-else class="fill-height")
    core-view(class="fill-height")
  v-snackbar(v-model="error" color="error" class="center-snackbar")
    span {{ error }}
  v-snackbar(v-model="success" color="success" class="center-snackbar")
    span {{ success }}
</template>

<style lang="scss">
@import '@/styles/index.scss';

/* Remove in 1.2 */
.v-datatable thead th.column.sortable i {
  vertical-align: unset;
}
</style>

<script>
import { usesPublicShell } from '@/router/public-shell';

export default {
  // mounted() {
  //   if (!this.$store.getters['auth/authUser'] || !this.$store.getters['auth/authUser'].locale) {
  //     console.log('No user locale');
  //     console.log(this.$store.getters['auth/authUser']);
  //     this.$i18n.locale = navigator.languages;
  //     console.log(this.$i18n.locale);
  //   } else {
  //     console.log('User locale');
  //     console.log(this.$store.getters['auth/authUser']);
  //     this.$i18n.locale = this.$store.getters['auth/authUser'].locale;
  //     console.log(this.$i18n.locale);
  //   }
  //   // console.log('Locale');
  //   // console.log(this.$i18n.locale);
  // },

  computed: {
    usesPublicShell() {
      return usesPublicShell(this.$route);
    },
    loggedIn() {
      //return true;
      if (!this.$store.getters['auth/authUser']) {
        return false;
      } else {
        return true;
      }
    },
    user() {
      return this.$store.getters['auth/authUser'];
    },
    displaySidebar() {
      return this.$store.state.displaySidebar;
    },
    displayMainToolbar() {
      return this.$store.state.displayMainToolbar;
    },
    displayWebsiteToolbar() {
      return this.$store.state.displayWebsiteToolbar;
    },
    error: {
      get() {
        let error = this.$store.getters['error'];
        if (error && error.response && error.response.data && error.response.data.message) {
          return error.response.data.message;
        } else {
          return error;
        }
      },
      set() {
        this.lodash.delay(() => this.$store.commit('SET_ERROR', null), 4000);
      },
    },
    success: {
      get() {
        return this.$store.getters['success'];
      },
      set() {
        this.lodash.delay(() => this.$store.commit('SET_SUCCESS', null), 4000);
      },
    },
  },
  watch: {
    user(user) {
      if (!user) {
        return;
      }

      if (!user.locale) {
        this.$i18n.locale = navigator.language;
      } else {
        this.$i18n.locale = user.locale;
      }
    },
  },
};
</script>
<style>
body {
  overscroll-behavior-y: none;
}
html {
  overscroll-behavior: none;
}
.center-snackbar .v-snack__content {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
